/* L&P retargeting quiz (rt): DOM, pixels, journey log, cart, lead.
   Flow: lp-quiz-rt-flow.js · Copy: lp-quiz-rt-copy.js · Spec: docs/superpowers/specs/2026-09-14-lp-retargeting-quiz-design.md */
(function () {
'use strict';
var F = window.LPRT_FLOW, C = window.LPRT_COPY;
if (!F || !C) { try { console.error('[lp-quiz-rt] flow/copy missing') } catch (e) {} return; }

var CFG = (function () { try { var el = document.querySelector('[data-lp-quiz-config]'); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } })();
var VARIANT = CFG.variant || 'rt';
var SITE = CFG.site || 'https://lapoedagar.com';
var MYSTERY = +(CFG.mystery_variant_id || 45928714698943);
var PIXELS = { meta: CFG.meta_pixel_id || '1639506919964880', tiktok: CFG.tiktok_pixel_id || 'CJL66RBC77UEAFO1GRPG', google: CFG.google_ads_id || 'AW-17548706483' };
var GADS_CONV = { QuizComplete: 'AW-17548706483/C0c0CNnw4dscELOF8K9B', QuizGiftClick: 'AW-17548706483/_ZM6CNzw4dscELOF8K9B' };
var LEAD = { post: 'https://docs.google.com/forms/d/e/1FAIpQLScr0dHwRCiJnnKEaB2dLWEc8UXyUHjVC-LAqmA2l_WccFS6DA/formResponse', name: 'entry.199874719', phone: 'entry.1778933271', journey: 'entry.1215223966' };
var JOURNEY = { post: 'https://docs.google.com/forms/d/e/1FAIpQLSchZjFaOZtC1A2JbTm5K_TjMmmrC6N-Zs7T9LCzMndzzOTUIQ/formResponse', session: 'entry.626601751', src: 'entry.373322878', screen: 'entry.1933156064', answer: 'entry.1231347150', next: 'entry.696230963', ad: 'entry.1748222045' };

var IMG = {
  dohaGoldLife: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/DOHL04.jpg?v=1785498684',
  genevaLife: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8802.jpg?v=1759232982',
  dubaiLife: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8797_2.jpg?v=1759232767',
  monacoLife: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8792.jpg?v=1759232505',   /* Adam 2026-09-15: the "heavy watch" option is Monaco on the wrist (was a slim Venize dress watch) */
  sydney: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/SYDL03.jpg?v=1785498683',
  workshop: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/workshop-artisan.jpg?v=1779552540',
  pressDuo: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/smartravel_500_x_250_px_1.png?v=1774282907',
  offerbox: 'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/offer-box.jpg?v=1779552434'
};
var SOCIAL = [
  'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-social-1.jpg?v=1786979463',
  'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-social-4.jpg?v=1789401663'   /* Adam 2026-09-14: replaces lp-social-2 */
];
var MODELS = {
  /* Adam 2026-09-15 (QA R1): the style pick decides the watch. Each gallery opens on the exact
     lifestyle photo the customer picked, and variant + price are the colour in that photo. */
  dubai: { name: 'L&P Dubai', variant: 'כסף · כחול', price: '549.90', gallery: [
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8797_2.jpg?v=1759232767',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/4_f46e2407-7eb2-48f0-8007-62b125c5716f.png?v=1755435557',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8796.jpg?v=1759232767',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/6_ed297bb0-47b7-4618-937c-152081999f0d.png?v=1759232767'] },
  doha: { name: 'L&P Doha', variant: 'כסף · זהב', price: '949.90', gallery: [
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/DOHL04.jpg?v=1785498684',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-doha-silver-gold-front.jpg?v=1787036448',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/DOHL02.jpg?v=1785498684',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/DOHL05.jpg?v=1785498684'] },
  monaco: { name: 'L&P Monaco', variant: 'כסף', price: '579.90', gallery: [
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8792.jpg?v=1759232505',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-monaco-silver-front.jpg?v=1787036928',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8791.jpg?v=1759232505',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-monaco-three-quarter-a.jpg?v=1787044007'] },
  sydney: { name: 'L&P Sydney', variant: 'שחור קלאסי', price: '729.90', gallery: [
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/SYDL03.jpg?v=1785498683',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-sydney-black-classic-front.jpg?v=1787036929',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-sydney-silver-black-front.jpg?v=1787036929',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-sydney-rose-gold-blue-front.jpg?v=1787036929'] },
  geneva: { name: 'L&P Geneva', variant: 'כחול · זהב', price: '629.90', gallery: [
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8802.jpg?v=1759232982',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-geneva-blue-gold-front.jpg?v=1787036929',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_8803.jpg?v=1759232982',
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/lp-geneva-black-classic-front.jpg?v=1787036929'] }
};

/* ─── pixels: init only what is not already on the page (theme loads the same Meta id) ─── */
try {
  if (!window.fbq) {
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s) }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', PIXELS.meta);
  } else {
    var byId = window.fbq.instance && window.fbq.instance.pixelsByID;
    if (byId && !byId[PIXELS.meta]) fbq('init', PIXELS.meta);
  }
} catch (e) {}
try {
  if (!window.ttq) {
    !function (w, d, t) { w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"]; ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }; for (var i = 0; i < ttq.methods.length; i++)ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)ttq.setAndDefer(e, ttq.methods[n]); return e }; ttq.load = function (e, n) { var r = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {}; var a = document.createElement("script"); a.type = "text/javascript", a.async = !0, a.src = r + "?sdkid=" + e + "&lib=" + t; var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(a, s) }; ttq.load(PIXELS.tiktok); }(window, document, 'ttq');
  }
} catch (e) {}
try {
  if (!window.gtag) {
    var gs = document.createElement('script'); gs.async = true; gs.src = 'https://www.googletagmanager.com/gtag/js?id=' + PIXELS.google; document.head.appendChild(gs);
    window.dataLayer = window.dataLayer || []; window.gtag = function () { dataLayer.push(arguments); }; gtag('js', new Date());
  }
  gtag('config', PIXELS.google, { send_page_view: false });
} catch (e) {}

function detectSrc() {
  try {
    var p = new URLSearchParams(location.search);
    if (p.get('src')) return p.get('src');
    if (p.has('fbclid')) return 'meta';
    if (p.has('ttclid')) return 'tiktok';
    if (p.has('gclid') || p.has('gbraid') || p.has('wbraid')) return 'google';
    if (p.get('utm_source')) return p.get('utm_source');
    var saved = sessionStorage.getItem('lp_quiz_src'); if (saved) return saved;
    var r = document.referrer || '';
    if (/facebook\.|instagram\./.test(r)) return 'meta';
    if (/tiktok\./.test(r)) return 'tiktok';
    if (/google\.|youtube\./.test(r)) return 'google';
    return 'direct';
  } catch (e) { return 'direct'; }
}
function detectAd() {
  try {
    var p = new URLSearchParams(location.search), parts = [];
    var camp = p.get('utm_campaign') || p.get('campaign_id') || '', adset = p.get('adset_id') || '', ad = p.get('utm_content') || p.get('ad_id') || '';
    if (camp) parts.push('c:' + camp); if (adset) parts.push('s:' + adset); if (ad) parts.push('a:' + ad);
    return parts.join('|');
  } catch (e) { return ''; }
}
var QSRC = detectSrc(), QAD = detectAd();
try { sessionStorage.setItem('lp_quiz_src', QSRC); } catch (e) {}
var SID = (function () {
  try { var s = sessionStorage.getItem('lp_quiz_sid'); if (!s) { s = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); sessionStorage.setItem('lp_quiz_sid', s); } return s; }
  catch (e) { return 'anon' + Math.floor(Math.random() * 1e9); }
})();

var STD_EVENT = { QuizLead: { meta: 'Lead', tiktok: 'SubmitForm' } };
function track(name, params) {
  var p = Object.assign({}, params || {}, { quiz_src: QSRC, quiz_variant: VARIANT }), std = STD_EVENT[name];
  try { if (window.fbq) fbq('trackCustom', name, p); } catch (e) {}
  try { if (window.fbq && std) fbq('track', std.meta, Object.assign({ value: 0, currency: 'ILS' }, p)); } catch (e) {}  // Meta flags a Lead with no currency
  try { if (window.ttq) ttq.track(name, p); } catch (e) {}
  try { if (window.ttq && std) ttq.track(std.tiktok, p); } catch (e) {}
  try { if (window.gtag) { gtag('event', name, p); if (GADS_CONV[name]) gtag('event', 'conversion', { send_to: GADS_CONV[name] }); } } catch (e) {}
}
window.lpQuizTrack = track;
function logJourney(screen, answer, next) {
  try {
    var fd = new FormData();
    fd.append(JOURNEY.session, SID); fd.append(JOURNEY.src, QSRC); fd.append(JOURNEY.screen, 'rt_' + (screen || ''));
    fd.append(JOURNEY.answer, String(answer || '').replace(/\s+/g, ' ').trim().slice(0, 120));
    fd.append(JOURNEY.next, next ? 'rt_' + next : ''); fd.append(JOURNEY.ad, (QAD ? QAD + '|' : '') + 'v:' + VARIANT);
    fetch(JOURNEY.post, { method: 'POST', mode: 'no-cors', body: fd, keepalive: true }).catch(function () {});
  } catch (e) {}
}

/* ─── state ─── */
var S = F.initialState(), cur = 'gate', stack = [], trail = [], completed = false, tInt = null;
/* QA 2026-09-15 C1: a fast double tap fired advance() twice and skipped the next screen,
   the objection answer included. Taps are locked from the first one until the next screen is drawn. */
var busy = false, sending = false, started = false;
function P() { return S.path === 'gift' ? 'gift' : 'self'; }
function model() { return MODELS[S.model] || MODELS.dubai; }   /* Adam 2026-09-15: the style pick decides the watch */
function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function para(t) { return String(t || '').trim().split(/\n{2,}/).map(function (x) { return '<p>' + x.replace(/\n/g, '<br>') + '</p>'; }).join(''); }
function fill(h) { var m = model(); return h.replace(/%%MODEL%%/g, m.name).replace(/%%PRICE%%/g, m.price); }
function opt(label, key) { return '<button type="button" class="opt" data-k="' + esc(key) + '">' + label + '</button>'; }
function q(t) { return '<h2>' + t + '</h2>'; }
function box(h, body) { return '<div class="copybox"><div class="headline">' + h + '</div>' + para(body) + '</div>'; }
function fig(k) { return '<img class="figimg' + (k === 'pressDuo' ? ' figimg-press' : '') + '" src="' + IMG[k] + '" alt="">'; }
function proof() { var k = F.proofFor(S, cur); return k ? '<div class="rt-proof">' + C.proof[P()][k] + '</div>' : ''; }
function media(c) {
  return (c.fig ? fig(c.fig) : '') +
    (c.social ? '<div class="lp-social">' + SOCIAL.map(function (u) { return '<img src="' + u + '" alt="לקוח עם שעון L&amp;P" loading="lazy">'; }).join('') + '</div>' : '');
}
function objectionAnswers(keys) { var a = C.obj[P()].a; return keys.map(function (k) { return opt(a[k], k); }).join(''); }

function html(id) {
  var p = P(), c;
  switch (id) {
    case 'who': return q(C.who.q) + opt(C.who.a.self, 'self') + opt(C.who.a.gift, 'gift');
    case 'obj': return q(C.obj[p].q) + objectionAnswers(F.objectionsFor(S.path).concat('none'));
    case 'deep':
      c = C.deep[p][S.objection];
      return box(c.h, c.body) + media(c) +
        '<button type="button" class="cta" data-k="next">' + C.next[p] + '</button>';
    case 'style':
      c = C.style[p];
      return q(c.q) + '<div class="imgopts">' + c.opts.map(function (o) {
        return '<div class="imgopt" data-k="' + o[1] + '"><img src="' + IMG[o[1]] + '" alt="" loading="lazy"><div class="t">' + o[0] + '</div></div>';
      }).join('') + '</div>' + proof();
    case 'moment':
      c = C.moment[p];
      return q(c.q) + c.a.map(function (t, i) { return opt(t, 'm' + i); }).join('') + proof();
    case 'more':
      return q(C.more[p].q) + objectionAnswers(F.remaining(S)) + opt(C.more[p].none, 'none');
    case 'short':
      c = C.short[p][S.second];
      /* Adam 2026-09-14: the short answer always carries an image, the same one as that objection's full answer */
      return box(c.h, c.body) + media(C.deep[p][S.second]) + '<button type="button" class="cta" data-k="next">' + C.next[p] + '</button>';
    case 'match':
      /* Adam 2026-09-14: the button has to be on screen without scrolling. Short offer line,
         gift banner, button. The objection line and trust row sit below the button. */
      c = C.match[p]; var m = model();
      return '<div class="rt-match">' +
        '<div class="rt-eyebrow">' + c.h + '</div>' +
        '<div class="rt-model">' + m.name + '</div>' +
        '<div class="rt-meta">' + m.variant + ' · <b>₪' + m.price + '</b></div>' +
        '<div class="rt-car" id="rtCar" dir="ltr">' + m.gallery.map(function (u) { return '<img src="' + u + '" alt="' + m.name + '">'; }).join('') + '</div>' +
        '<div class="rt-dots" id="rtDots">' + m.gallery.map(function (u, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') + '</div>' +
        '<div class="rt-offer">' + fill(c.body) + '</div>' +
        '<div class="rt-gift"><span class="rt-gift-i">🎁</span><div class="rt-gift-b">' +
          '<div class="rt-gift-t">' + c.gift + '</div>' +
          '<div class="rt-gift-s"><span id="rtGiftOk" hidden>✓ נשמרה לך · </span>שמורה לך עוד <b id="tmr">24:00:00</b></div>' +
        '</div></div>' +
        '<a class="cta rt-cta" id="rtPrimary" href="' + SITE + '/collections/bestsellers">' + c.primary + '</a>' +
        '<button type="button" class="rt-secondary" data-k="lead">' + c.secondary + '</button>' +
        '<div class="rt-check"><b>✓</b><span>' + c.closed[S.objection || 'none'] + '</span></div>' +
        '<div class="rt-trust">שנתיים אחריות · החזרה חינם · משלוח מהיר</div>' +
        '</div>';
    case 'lead':
      return box(C.lead.h, C.lead.body) + '<div class="copybox" style="padding:22px">' +
        '<input id="lead_name" class="finput" type="text" placeholder="שם מלא" autocomplete="name">' +
        '<input id="lead_phone" class="finput" type="tel" placeholder="מספר טלפון" autocomplete="tel" dir="rtl">' +
        '<div id="lead_err" style="color:#c0392b;font-size:13.5px;min-height:18px;margin-top:2px"></div>' +
        '<button type="button" class="cta" data-k="submit">' + C.lead.btn + '</button>' +
        '<div class="leadnote">' + C.lead.note + '</div></div>';
    case 'done':
      return box(C.done.h, C.done.body) + '<a class="cta-textlink" href="' + SITE + '/collections/bestsellers">' + C.done.link + '</a>';
  }
  return '';
}

function swap(h) {
  var st = document.getElementById('stage');
  st.style.animation = 'none'; void st.offsetWidth; st.style.animation = '';
  st.innerHTML = h;
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
function render(id) {
  clearInterval(tInt);
  var back = document.getElementById('lpBack'); if (back) back.hidden = !stack.length || id === 'done';
  cur = id;
  document.getElementById('bar').style.width = (F.PROGRESS[id] || 50) + '%';
  document.getElementById('stepc').textContent = '';
  if (id === 'proc') return runProc();
  swap(html(id));
  busy = false;
  if (id === 'match') onMatch();
}
function runProc() {
  var msgs = C.proc[P()], i = 0;
  swap('<div class="proc"><div class="spinner"></div><div class="procmsg" id="pm">' + msgs[0] + '</div><div class="procbar"><i id="pb"></i></div></div>');
  (function step() {
    document.getElementById('pb').style.width = ((i + 1) / msgs.length * 100) + '%';
    document.getElementById('pm').textContent = msgs[i];
    i++;
    setTimeout(i < msgs.length ? step : function () { advance(null); }, 900);
  })();
}
/* QuizObjection `objection` = the phrase the Meta audiences match (i_contains), see
   brands/la-poedega/tools/quiz_objection_audiences.json. choice has no audience: it keeps its key. */
var OBJ_HE = { price: 'טוב מדי', photos: 'כמו שהבטחתם', trust: 'מותג שאני לא מכיר', fit: 'החזרות', none: 'תראו לי את השעון' };
function advance(answer, label) {
  if (label) {
    trail.push(cur + ': ' + label);
    logJourney(cur, label, null);
    if (cur === 'who') track('QuizPath', { path: answer });
    else if (cur === 'obj') track('QuizObjection', { objection: OBJ_HE[answer] || answer, objection_key: answer, path: S.path });
    else if (cur === 'more') track('QuizObjection2', { objection: answer, path: S.path });
    else track('QuizAnswer', { step: cur, answer: answer, path: S.path });
  }
  var r = F.next(S, cur, answer);
  /* push the state from BEFORE this answer, so back really undoes it */
  if (cur !== 'gate' && cur !== 'proc') stack.push({ id: cur, s: S });
  S = r[0]; render(r[1]);
}

/* ─── match: gift into the cart without a click, attributes on the order ─── */
function attrs() {
  return { 'Quiz source': QSRC, 'Quiz path': S.path, 'Quiz objection': S.objection, 'Quiz objection 2': S.second,
           'Quiz model': model().name, 'Quiz style': S.model, 'Quiz variant': VARIANT };
}
function onMatch() {
  /* 2026-10-14: the cart is only marked; lp-mystery-claim adds the MysteryBox with the first paid watch */
  var at = attrs(); at._lp_mystery = 'quiz';
  fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: at }) })
    .then(function (res) { if (res.ok) { var ok = document.getElementById('rtGiftOk'); if (ok) ok.hidden = false; } })
    .catch(function () {});
  if (!completed) {
    completed = true;
    track('QuizComplete', { path: S.path, objection: S.objection, objection2: S.second, model: model().name });
    logJourney('match', 'COMPLETE|' + model().name, '');
  }
  var pr = document.getElementById('rtPrimary');
  if (pr) pr.addEventListener('click', function () {
    track('QuizGiftClick', { path: S.path, objection: S.objection, model: model().name });
    logJourney('match', 'GIFT_CLICK', 'collection');
  });
  var car = document.getElementById('rtCar'), dots = document.querySelectorAll('#rtDots i');
  if (car && dots.length) car.addEventListener('scroll', function () {
    var mid = car.scrollLeft + car.clientWidth / 2, best = 0, bestD = 1e9;
    Array.prototype.forEach.call(car.children, function (el, i) {
      var d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - mid); if (d < bestD) { bestD = d; best = i; }
    });
    Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('on', i === best); });
  }, { passive: true });
  startTimer();
}
function deadline() {
  var d = +(localStorage.getItem('lp_quiz_deadline') || 0);
  if (!d || d < Date.now()) { d = Date.now() + 24 * 3600 * 1000; localStorage.setItem('lp_quiz_deadline', d); }
  return d;
}
function startTimer() {
  var el = document.getElementById('tmr'); if (!el) return;
  function tick() {
    var ms = Math.max(0, deadline() - Date.now());
    el.textContent = [Math.floor(ms / 3600000), Math.floor(ms % 3600000 / 60000), Math.floor(ms % 60000 / 1000)].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
  }
  tick(); tInt = setInterval(tick, 1000);
}

function submitLead() {
  if (sending) return;
  var name = document.getElementById('lead_name').value.trim();
  var phone = document.getElementById('lead_phone').value.trim().replace(/[\s-]/g, '');
  var err = document.getElementById('lead_err');
  if (!name) { err.textContent = 'רגע, חסר שם'; return; }
  if (!/^0\d{8,9}$/.test(phone) && !/^\+?\d{9,13}$/.test(phone)) { err.textContent = 'מספר הטלפון לא נראה תקין'; return; }
  err.textContent = '';
  sending = true;
  var fd = new FormData();
  fd.append(LEAD.name, name); fd.append(LEAD.phone, phone);
  fd.append(LEAD.journey, ['שאלון: ' + VARIANT, 'מקור: ' + QSRC, 'מסלול: ' + (S.path === 'gift' ? 'מתנה לבן זוג' : 'לעצמו'),
    'דגם שהותאם: ' + model().name].concat(trail).join('\n').slice(0, 2500));
  fetch(LEAD.post, { method: 'POST', mode: 'no-cors', body: fd })
    .then(function () { track('QuizLead', { path: S.path, objection: S.objection }); logJourney('lead', 'LEAD', 'done'); advance(null); })
    .catch(function () { sending = false; err.textContent = 'השליחה לא עברה. יש חיבור לאינטרנט? נסו שוב.'; });
}

/* ─── wiring ─── */
document.getElementById('stage').addEventListener('click', function (e) {
  var el = e.target.closest('[data-k]'); if (!el) return;
  if (el.getAttribute('data-k') !== 'submit') { if (busy) return; busy = true; }
  var k = el.getAttribute('data-k');
  if (k === 'submit') return submitLead();
  if (k === 'next') return advance(null);
  if (k === 'lead') { logJourney('match', 'LEAD_CLICK', 'lead'); return advance('lead'); }
  el.classList.add('picked');
  var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
  setTimeout(function () { advance(k, label); }, 160);
});
window.goBack = function () {
  if (busy) return;
  var prev = stack.pop(); if (!prev) return;
  S = prev.s; render(prev.id);
};
document.getElementById('startQuizBtn').addEventListener('click', function () {
  if (started) return; started = true;
  track('QuizStart', {}); logJourney('gate', 'start', 'who');
  document.getElementById('landingPage').style.display = 'none';
  document.getElementById('quizApp').classList.add('active');
  window.scrollTo({ top: 0, behavior: 'instant' });
  advance(null);
});
track('QuizView', {});
logJourney('gate', 'view', '');
})();
